import { MenuItem } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { toDataCy } from "lib/to-data-cy"

export function ScheduleViewModeMenuItem({ item }) {
    const { currentShowDetail, currentOnePage, onSelectMode } = useBoundContext()
    const { label, onePage, showDetail } = item

    return (
        <MenuItem
            data-cy={toDataCy("schedule-view-mode", label)}
            selected={currentShowDetail === showDetail && currentOnePage === onePage}
            onClick={handleClick}
        >
            {label}
        </MenuItem>
    )

    function handleClick() {
        onSelectMode(showDetail, onePage)
    }
}
